import React from "react";
import HtmlViewer from "../../../SubComponents/HtmlViewer/HtmlViewer";

const QuestionHTMLSection = (props) => {
  const { handleChangeFileHTML, copyFileUploadHTML, formData, htmlPrintUrl } = props;

  return (
    <>
      <div className="dropdownDiv">
        <label className="questionCopyHead">
          {`Question Printable Data(HTML)`}
        </label>
        <input
          type="file"
          name="question_file_path"
          id="question_file_path"
          className="fileChooseAddDetails"
          onChange={(e) => handleChangeFileHTML(e)}
          accept=".html"
        ></input>
        <button
          type="button"
          className="btnFilesUploadAddDetails"
          onClick={(e) => copyFileUploadHTML(e)}
          style={{ margin: 0, width: "fit-content" }}
        >
          Upload
        </button>
      </div>
      <div style={{ fontSize: "12px", textAlign: "center" }}>
        {formData?.html_data_file_path}
      </div>
      {/* {formData?.html_data_file_path && (
        <div className="docxFileDiv">
          <HtmlViewer htmlFilePath={formData?.html_data_file_path} />
        </div>
      )} */}
      {(htmlPrintUrl || formData?.html_data_file_path) && (
        <div className="docxFileDiv">
          <iframe
            src={htmlPrintUrl || formData?.html_data_file_path}
            title="question-html-data"
            style={{ width: "100%" }}
          />
        </div>
      )}
    </>
  );
};

export default QuestionHTMLSection;
